import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import { futurizerApi } from './futurizerApi';

const store = configureStore({
  reducer: {
    auth: authReducer,
    [futurizerApi.reducerPath]: futurizerApi.reducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(futurizerApi.middleware),
});

export default store;
